import React, { useState } from 'react';

export default function GalleryGrid({ photos }) {
  const [lightbox, setLightbox] = useState(null);

  if (!photos || photos.length === 0) {
    return <p style={styles.empty}>Noch keine Fotos vorhanden.</p>;
  }

  return (
    <>
      <div style={styles.grid}>
        {photos.map(photo => (
          <div key={photo.filename} style={styles.item} onClick={() => setLightbox(photo)}>
            <img src={photo.url} alt={photo.caption || ''} style={styles.img} loading="lazy" />
            {photo.caption && <div style={styles.caption}>{photo.caption}</div>}
          </div>
        ))}
      </div>

      {lightbox && (
        <div style={styles.overlay} onClick={() => setLightbox(null)}>
          <div style={styles.lightboxInner} onClick={e => e.stopPropagation()}>
            <img src={lightbox.url} alt={lightbox.caption || ''} style={styles.lightboxImg} />
            {lightbox.caption && <p style={styles.lightboxCaption}>{lightbox.caption}</p>}
            <button style={styles.closeBtn} onClick={() => setLightbox(null)}>✕ Schließen</button>
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' },
  item: { position: 'relative', borderRadius: '8px', overflow: 'hidden', cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', aspectRatio: '4/3', backgroundColor: '#eee' },
  img: { width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.3s' },
  caption: { position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.55)', color: 'white', padding: '0.5rem 0.75rem', fontSize: '0.85rem', fontFamily: 'Arial, sans-serif' },
  empty: { textAlign: 'center', color: '#888', fontFamily: 'Arial, sans-serif', padding: '3rem' },
  overlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' },
  lightboxInner: { backgroundColor: 'white', borderRadius: '10px', padding: '1.5rem', maxWidth: '90vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' },
  lightboxImg: { maxWidth: '80vw', maxHeight: '65vh', objectFit: 'contain', borderRadius: '6px' },
  lightboxCaption: { color: '#555', fontFamily: 'Arial, sans-serif', textAlign: 'center', margin: 0 },
  closeBtn: { padding: '0.5rem 1.5rem', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontFamily: 'Arial, sans-serif', fontSize: '0.95rem' },
};
